export default __webpack_public_path__ + "static/media/Fred.dd5eab3a.jpeg";